import { Link } from "@/lib/link";
import { ShieldCheck, Landmark, FileCheck2, Handshake, ArrowRight } from "lucide-react";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";
import ScrollReveal from "@/components/common/ScrollReveal";
import SectionHeading from "@/components/common/SectionHeading";
import { Button } from "@/components/ui/button";

const pillars = [
    { Icon: ShieldCheck, tKey: "governmentPage.pillars.msmE.title", dKey: "governmentPage.pillars.msmE.description" },
    { Icon: FileCheck2, tKey: "governmentPage.pillars.documentation.title", dKey: "governmentPage.pillars.documentation.description" },
    { Icon: Landmark, tKey: "governmentPage.pillars.buyers.title", dKey: "governmentPage.pillars.buyers.description" },
    { Icon: Handshake, tKey: "governmentPage.pillars.partnerships.title", dKey: "governmentPage.pillars.partnerships.description" },
];

export default function Government() {
    const { t } = useTranslation();
    return (
        <>
            <SEO
                title="Government & Institutions — MSME Export Partner | Exportfy.world"
                description="Exportfy.world is an MSME merchant exporter and execution partner for state export-promotion councils, government tenders, and institutional buyers."
                path="/government"
            />
            <PageHero
                eyebrow={t("governmentPage.hero.eyebrow")}
                title={t("governmentPage.hero.title")}
                subtitle={t("governmentPage.hero.subtitle")}
                image="https://images.unsplash.com/photo-1541872703-74c5e44368f9?w=1600"
            />
            <section className="section-y">
                <div className="container-x">
                    <ScrollReveal><SectionHeading eyebrow={t("governmentPage.pillars.eyebrow")} title={t("governmentPage.pillars.title")} /></ScrollReveal>
                    <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {pillars.map(({ Icon, tKey, dKey }, i) => (
                            <ScrollReveal key={tKey} delay={i * 40}>
                                <div className="bg-white border border-slate-200 rounded-2xl p-7 h-full">
                                    <div className="w-11 h-11 rounded-xl bg-[#0A2540] flex items-center justify-center text-white"><Icon className="w-5 h-5" strokeWidth={1.75} /></div>
                                    <div className="mt-5 font-bold text-lg text-[#0A2540]">{t(tKey)}</div>
                                    <p className="mt-2 text-sm text-slate-500 leading-relaxed">{t(dKey)}</p>
                                </div>
                            </ScrollReveal>
                        ))}
                    </div>
                </div>
            </section>
            <section className="section-y bg-[#0A2540] text-white">
                <div className="container-x flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
                    <div>
                        <div className="overline text-emerald-400">{t("governmentPage.cta.eyebrow")}</div>
                        <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight">{t("governmentPage.cta.title")}</h2>
                        <p className="mt-3 text-white/70 max-w-2xl">{t("governmentPage.cta.description")}</p>
                    </div>
                    <Link to="/contact"><Button className="rounded-full bg-white text-[#0A2540] hover:bg-slate-100 font-semibold px-7 py-6">{t("governmentPage.cta.button")} <ArrowRight className="ml-2 w-4 h-4" /></Button></Link>
                </div>
            </section>
        </>
    );
}
